type ModuleName = "classroom"
export const MODULE_NAME: ModuleName = "classroom"
